module.exports = __webpack_public_path__ + "img/biogen_logo.14c84002.png";